module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAAAAXNSR0IArs4c6QAAAPRJREFUOBFjZMACSkpKkv///z8HWYqRkTGlp6dnLrIYiM2ELgDly2IRxybGwFhRUaHy58+fBKAGc6CtLCCNQFoBaKMCiA0DQLEHQLEHID6Q/gOkTrKwsCxgAWqOBkpWgyRgAKgAxoTTUAMVQAJA9SDKBaj3N8gLT0A8MsETsFXAQHMAmrqfFEOALnIEBuoBjEAEShSCJEE0zEBsYjA5DAOAEhdAJoNomCIcYmBpbAYg6SPMHDUAd14gHHpQFRQHIjjzIFsHSpHFxcWw9A6WwiYG0wN2ATClgXMHTJAYGqYHln3PMDExVQJt4iBS8w9ubu7TILUAS01YrxSu0dEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/ic_delete.png
// module id = 217
// module chunks = 170